import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";

export function PickModeBanner({ onCancel }: { onCancel: () => void }) {
  const isMobile = useIsMobile();

  return (
    <div
      data-requests
      data-testid="request-pick-banner"
      className={
        isMobile
          ? "pointer-events-auto fixed inset-x-0 bottom-0 z-[60] flex items-center justify-between gap-3 bg-foreground px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 text-background"
          : "pointer-events-auto fixed bottom-6 left-1/2 z-[60] flex -translate-x-1/2 items-center gap-3 rounded-full bg-foreground px-4 py-2 text-background shadow-lg"
      }
      onPointerDownCapture={(e) => e.stopPropagation()}
    >
      <span className="text-sm">{isMobile ? "Tap the thing you mean" : "Click the thing you mean"}</span>
      <Button
        type="button"
        size="sm"
        variant="secondary"
        data-testid="request-pick-cancel"
        onClick={onCancel}
        className="min-h-[44px]"
      >
        Just write
      </Button>
    </div>
  );
}
